import { render, staticRenderFns } from "./LegendItem.html?vue&type=template&id=6fb5571a&external"
import script from "./LegendItem.ts?vue&type=script&lang=ts&external"
export * from "./LegendItem.ts?vue&type=script&lang=ts&external"
import style0 from "./LegendItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports